"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../theming/make-styles.js";
const useStyles = makeStyles()(({ palette }, { color }) => ({
    icon: { color: color ? palette(color).icon.color : undefined },
}));
export const Icon = React.forwardRef(function Icon(_a, ref) {
    var { className, color } = _a, props = __rest(_a, ["className", "color"]);
    const { classes, cx } = useStyles({ color });
    return (_jsx("svg", Object.assign({ ref: ref, className: cx(classes.icon, className), fill: "none", height: "20", shapeRendering: "geometricPrecision", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", viewBox: "0 0 24 24", width: "20" }, props)));
});
export default Icon;
//# sourceMappingURL=icon.js.map